var app = angular.module("leonardo");

var DynamicFormBreadCrumb = function($scope, $state, PermissionService, AuthDataService) {

  $scope.permissionService = PermissionService;
  $scope.currentFolder = {};
  $scope.authDataService = AuthDataService;

  $scope.goToFolder = function(folder, documents) {
    var url = 'documents.dynamic-forms-folder';
    if (documents) {
      url = 'documents.list';
    }
    let id = null;
    if(folder){
      id = folder.id ? folder.id : folder;
    }
    if (id === $scope.currentFolder.id) return;
    $state.go(url, {pk: id});
  };

  $scope.getClassButton = function(key) {
    if(key == $scope.currentFolder.id)
      return 'btn-go';
    return 'btn-go-back-breadcrumb';
  };

  $scope.$on('folder:loaded', function ($event, folder) {
    $scope.currentFolder = folder;
  });

  $scope.isShowAccountTag = function() {
    return $state.current.name === 'documents.dynamic-forms.account-tags' ||
      $state.current.name === 'documents.dynamic-forms.system-tags';
  };
};

app.controller('DynamicFormBreadCrumb', ['$scope', '$state', 'PermissionService', 'AuthDataService', DynamicFormBreadCrumb]);
